import { useContext, useMemo } from "react";
import { UserContext } from "../context";
import { hasAdminAccess } from "../utils/authz";

/**
 * Hook de conveniencia para consumir el usuario desde el contexto global.
 * Retorna también flags derivados útiles para la UI.
 */
export default function useUser() {
  const user = useContext(UserContext);

  const derived = useMemo(() => {
    const isAdmin = hasAdminAccess(user);
    return { isAdmin };
  }, [user]);

  return {
    user,
    ...derived,
    // alias comunes
    username: user?.username,
    email: user?.email,
    accessToken: user?.access,
    refreshToken: user?.refresh,
  };
}
